import { configureStore } from '@reduxjs/toolkit'
import blockEditSlice from './features/blockEdit/blockEditSlice'

export const store = configureStore({
    reducer: {
        isBlockEdit: blockEditSlice,
    },
})